<template>
  <div v-if="documentElement">
    <v-layout row>
      <v-flex xs12 md12 class="templatePanel" id="templateHeader" v-if="edit">
        <Header
          :templateRevisionId="templateRevisionId"
          :navigation="navigation"
          :selectedObjectId="selectedObjectId"
          @triggerRefresh="fetchDocumentElement"
          @updateSelected="updateSelected"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex
        xs12
        md3
        id="templateSidebar"
        class="templatePanel templateNavigator"
      >
        <NavigatorItem
          :navigation="documentElement"
          :indent="0"
          :selectedObjectId="selectedObjectId"
          @updateNavigation="updateNavigator($event)"
        />
        <block-object-navigator
          v-for="blockObject in documentElement.blockObjects"
          :key="blockObject.id"
          :navigation="blockObject"
          :indent="1"
          :selectedObjectId="selectedObjectId"
          @updateNavigation="updateNavigator($event)"
        />
      </v-flex>
      <v-flex
        xs12
        md9
        id="templateMain"
        class="templatePanel templateNavigator"
      >
        <block-object-render
          v-for="blockObject in documentElement.blockObjects"
          :key="blockObject.id"
          :navigation="blockObject"
          :selectedObjectId="selectedObjectId"
          @triggerRefresh="triggerRefresh"
          @updateNavigation="updateMain($event)"
        />
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      :multi-line="false"
      :timeout="1500"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Header from "@/components/document/revision/Header";
import NavigatorItem from "@/components/document/revision/navigator/NavigatorItem";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Editor",
  props: ["templateRevisionId"],
  components: { Header, NavigatorItem },
  data() {
    return {
      documentElement: null,
      edit: true,
      selectedObjectId: null,
      optionsNavigator: {
        container: "#templateSidebar",
        easing: "ease-in",
        duration: 50,
        offset: -60,
        force: true,
        cancelable: true,
        // onStart: function(element) {
        // scrolling started
        // },
        // onDone: function(element) {
        // scrolling is done
        // },
        // onCancel: function() {
        // scrolling has been interrupted
        // },
        x: false,
        y: true
      },
      optionsMain: {
        container: "#templateMain",
        easing: "ease-in",
        duration: 50,
        offset: -60,
        force: true,
        cancelable: true,
        // onStart: function(element) {
        // scrolling started
        // },
        // onDone: function(element) {
        // scrolling is done
        // },
        // onCancel: function() {
        // scrolling has been interrupted
        // },
        x: false,
        y: true
      },
      navigation: null,
      snackbar: false,
      snackbarText: null
    };
  },
  methods: {
    async fetchDocumentElement() {
      const response = await nbmlaw.get(
        `/cors/admin/document/templateRevisions/${this.$route.params.id}/documentElement`
      );
      // console.log(response.data);
      this.documentElement = response.data;
    },
    async fetchNavigation() {
      const response = await nbmlaw.get(
        `/cors/admin/document/navigations/${this.selectedObjectId}`
      );
      // console.log(response.data);
      this.navigation = response.data;
    },
    updateNavigator(navigation) {
      // console.log(navigation);
      this.selectedObjectId = navigation.id;
      this.$nextTick(() => {
        this.$scrollTo(`#renderItem${this.selectedObjectId}`, this.optionsMain);
      });
    },
    updateMain(navigation) {
      // console.log(navigation);
      this.selectedObjectId = navigation.id;
      this.$nextTick(() => {
        this.$scrollTo(
          `#navigatorItem${this.selectedObjectId}`,
          this.optionsNavigator
        );
      });
    },
    updateSelected(selectedObjectId) {
      this.selectedObjectId = selectedObjectId;
    },
    triggerRefresh() {
      // this.fetchDocumentElement();
      this.snackbar = true;
      this.snackbarText = "Saved changes";
    }
  },
  watch: {
    templateRevisionId: {
      immediate: true,
      handler() {
        this.fetchDocumentElement();
      }
    },
    selectedObjectId: {
      immediate: true,
      handler() {
        if (this.selectedObjectId) {
          this.fetchNavigation();
        } else {
          this.navigation = null;
        }
      }
    },
    documentElement: {
      handler() {
        if (!this.selectedObjectId) {
          this.selectedObjectId = this.documentElement.id;
        }
      }
    }
  }
};
</script>

<style>
.templateRevision {
  padding: 10px;
  background: #dddddd;
  font-size: 8pt;
}

.templatePanel {
  border: 1px solid gray;
}

.templateHeading {
  font-size: 14pt;
  font-weight: bold;
}

.templateNavigator {
  padding: 5px;
  overflow: auto;
}

.templateMain {
  padding: 5px;
  overflow: auto;
}

.templateBold {
  font-weight: bold;
}

.templateItalic {
  font-style: italic;
}

.templateUnderline {
  text-decoration: underline;
}

.templateOmit {
  border: 1px dotted gray;
}

.templateOmitDefault {
  border: 1px dotted gray;
  opacity: 0.3;
  filter: grayscale(100%);
  background: #dddddd;
}

.templateOmitToggle {
  font-size: 0.8em;
  color: gray;
  border-bottom: 1px dotted gray;
  margin-bottom: 5px;
  display: block;
}

.templateOmitSection {
  padding: 2px;
}

.templatePlaceholder {
  color: green;
}

.templatePlaceholderEntry {
  color: red;
}

.templateListSpace {
  margin-top: 0;
}

.templateListSpace li {
  margin-bottom: 1em;
}

.templateSpace {
  margin-bottom: 1em;
}

.templateIndent {
  margin-left: 10px;
}

.templateSelected {
  background: #ddddff;
}

.templateBorder {
  border: 1px solid gray;
}

.templatePad {
  padding: 3px;
}

.templateShade {
  background: #dddddd;
}

.templateCollapse {
  border-collapse: collapse;
}

.templateCentre {
  text-align: center;
}

.templateRight {
  text-align: right;
}

.templateMove {
  color: #dddddd;
  float: right;
  margin-left: 5px;
  float: right;
}

a.templateMove:link {
  text-decoration: none;
  color: blue;
}

a.templateMove:hover {
  text-decoration: underline;
  color: blue;
}

a.nostyle:link {
  text-decoration: inherit;
  color: inherit;
}

a.nostyle:visited {
  text-decoration: inherit;
  color: inherit;
}
</style>